import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, Home, Search } from 'lucide-react';

export const NotFoundPage: React.FC = () => {
  return (
    <div className="max-w-xl mx-auto px-4 py-20 text-center space-y-6">
      <div className="w-16 h-16 bg-slate-100 rounded-2xl flex items-center justify-center mx-auto text-slate-500">
        <AlertTriangle className="w-8 h-8" />
      </div>
      <div className="space-y-2">
        <h1 className="text-3xl font-black text-navy-950">404 — Page Not Found</h1>
        <p className="text-sm text-slate-600">
          The requested page or alert record does not exist or may have expired from official broadcast history.
        </p>
      </div>

      <div className="flex flex-wrap items-center justify-center gap-3 pt-4">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-navy-900 text-white rounded-xl text-xs sm:text-sm font-semibold hover:bg-navy-800 transition-colors shadow-xs"
        >
          <Home className="w-4 h-4" />
          <span>Return Home</span>
        </Link>
        <Link
          to="/alerts"
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-white border border-slate-300 text-navy-900 rounded-xl text-xs sm:text-sm font-semibold hover:bg-slate-50 transition-colors shadow-xs"
        >
          <Search className="w-4 h-4" />
          <span>Search Alerts</span>
        </Link>
      </div>
    </div>
  );
};

